import { jsx as _jsx } from "react/jsx-runtime";
import { GoogleOAuthProvider } from "@react-oauth/google";
export var WithGoogleAuth = function (_a) {
    var children = _a.children;
    return (_jsx(GoogleOAuthProvider, { clientId: "".concat(process.env.CLIENT_ID), children: children }));
};
